export default __webpack_public_path__ + "static/media/CaretDown_4.f8ac103c.svg";